export default class Liderancas {
    constructor() {
        this.sections = document.querySelectorAll('.component-liderancas');
        this.ready();
    }

    ready() {

        this.sections.forEach(section => {
            const allTabsMenu = section.querySelectorAll('.tab-menu-item')
            const allTabsContent = section.querySelectorAll('.tab-content')
            allTabsMenu.forEach(menu => {
                menu.addEventListener('click', () => {
                    allTabsMenu.forEach(menuClear => {
                        menuClear.classList.remove('active')
                    })
                    const tab = menu.dataset.tab
                    menu.classList.add('active')
                    allTabsContent.forEach(tabClear => {
                        tabClear.classList.remove('active')
                    })
                    section.querySelector('#tab-'+tab).classList.add('active')
                })
            })         
        })

    }

}

if (document.querySelector('.component-liderancas')) {
    new Liderancas();
}